import service from '@/utils/request.js'
import axios from 'axios'
import { localData } from "@/utils/local.js"

// 定义数据
let carToken = '';
if (localStorage.getItem('UCAR360_TOKEN') && localStorage.getItem('UCAR360_TOKEN') !== 'undefined') {
  carToken = JSON.parse(localStorage.getItem('UCAR360_TOKEN'))
}
// pre和ucstest，反之401
// const url_api = "http://apitest.juhepai.cn" // 测试环境
// ucs服务，反之401
const url_api = "https://carapi.smart360.cn" // 线上环境

// 大区数据定义
const regionList = [
  { id: 3, name: '北部' },
  { id: 1, name: '东部' },
  { id: 4, name: '华南' },
  { id: 5, name: '西部' },
  { id: 2, name: '中部' },
];

// 拍卖状态数据定义
const auctionStatusList = [
  { id: 1, name: '审核中', value: 1 },
  { id: 2, name: '审核通过', value: 2 },
  { id: 3, name: '审核驳回', value: 3 },
  { id: 4, name: '中拍', value: 4 },
  { id: 5, name: '交易成功', value: 5 },
  { id: 6, name: '交易取消', value: 6 },
  { id: 7, name: '流拍', value: 7 },
  { id: 8, name: '取消上拍', value: 8 }
];

// 获取拍卖平台列表
async function getAuctionAllList() {
  return new Promise((resolve, reject) => {
    service.getRequestJson('/cooperator/list').then(res => {
      resolve(res);
    }).catch(err => {
      reject(err);
    });
  });
}


// 获取拍卖平台列表
async function getAuctionPlatformList() {
  return new Promise((resolve, reject) => {
    service.getRequestJson('/cooperator/list?lowSalvageValue=0').then(res => {
      resolve(res);
    }).catch(err => {
      reject(err);
    });
  });
}

// 获取报废拍卖平台列表
async function getScrapAuctionPlatformList() {
  return new Promise((resolve, reject) => {
    service.getRequestJson('/cooperator/list?lowSalvageValue=1').then(res => {
      resolve(res);
    }).catch(err => {
      reject(err);
    });
  });
}

// 获取大区列表
function getRegionList() {
  return Promise.resolve(regionList);
}

// 获取拍卖状态列表
function getAuctionStatusList() {
  return Promise.resolve(auctionStatusList);
}

function getSmartToken() {
  return new Promise((resolve, reject) => {
    // if (carToken) {
    //   resolve(carToken);
    // } else {
    service.getRequest(`/common/smart360/token`).then(res => {
      carToken = res;
      localStorage.setItem('UCAR360_TOKEN', JSON.stringify(carToken))
      resolve(carToken);
    })
    // }
  })
}


async function getCity(data) {
  carToken = await getSmartToken()
  let _citys = localData("get", "UCAR360_CITY");
  if (_citys) {
    return Promise.resolve(_citys);
  } else {
    return new Promise((resolve, reject) => {
      axios.get(`${url_api}/bs/district/list`,
        {
          headers: {
            token: carToken.token
          },
          params: {}
        }).then(res => {
          if (res.status == 200) {
            _citys = res.data;
            localData("set", "UCAR360_CITY", _citys);
            resolve(_citys);
          }
        })
    });
  }
}

// 获取品牌数据
async function getBrandList() {
  carToken = await getSmartToken()
  let brandList = localData("get", "UCAR360_BRAND") || '';
  if (brandList) {
    return Promise.resolve(brandList);
  } else {
    return new Promise((resolve, reject) => {
      axios.get(`${url_api}/bs/brand/list`,
        {
          headers: {
            token: carToken.token
          },
          params: {}
        }).then(res => {
          if (res.status == 200) {
            brandList = res.data.data;
            localData("set", "UCAR360_BRAND", brandList);
            resolve(brandList);
          }
        }).catch((err) => {
          localStorage.removeItem('UCAR360_TOKEN')
          carToken = ''
          reject(err)
        })
    });
  }
}

// 选择品牌之后的回调
async function changeBrand(brandId) {
  carToken = await getSmartToken()
  let _brandId = '';
  if (!carToken) {
    return;
  }
  try {
    return new Promise((resolve, reject) => {
      axios.get(`${url_api}/bs/mfrs/series/brandId/${brandId}`,
        {
          headers: {
            token: carToken.token
          },
          params: {}
        }).then(res => {
          if (res.status == 200) {
            _brandId = res.data.data;
            resolve(_brandId);
          }
        }).catch((err) => {
          localStorage.removeItem('UCAR360_TOKEN')
          carToken = ''
          reject(err)
        })
    });
  } catch (err) {
    console.log(err);
  }
}

// 选择车系之后的回调
async function changeSerial(seriesId) {
  carToken = await getSmartToken()
  let _seriesId = '';
  return new Promise((resolve, reject) => {
    axios.get(`${url_api}/bs/model/seriesId/${seriesId}`,
      {
        headers: {
          token: carToken.token
        },
        params: {}
      }).then(res => {
        if (res.status == 200) {
          _seriesId = res.data.data;
          resolve(_seriesId);
        }
      })
  });
}

function getEnv(env) {
  if (env === 'development') {
    return 'https://wwwtest.yifengpai.com'
  } else if (env === 'production') {
    return 'https://ucar360.com.cn'
  }
}



export default {
  getSmartToken,
  getBrandList,
  changeBrand,
  changeSerial,
  getEnv,
  getCity,
  getRegionList, // 新增大区列表方法
  getAuctionStatusList, // 新增拍卖状态列表方法
  getAuctionPlatformList, // 新增拍卖平台列表方法
  getScrapAuctionPlatformList, // 新增报废拍卖平台列表方法
  getAuctionAllList, // 新增所有拍卖平台列表方法
}
